import { Injectable } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BaseService } from '../../base.service';
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class EduCategoryService extends BaseService {
    constructor(
        private http: HttpClient
    ) {
        super();
    }

    getListEduCategory() {
        return this.http.get(this.BaseURI + '/EduCategory/List');
    }

    getEduCategoryById(guid: any) {
        return this.http.get(this.BaseURI + '/EduCategory/' + guid);
    }

    deleteEduCategory(guid: any) {
        return this.http.delete(this.BaseURI + '/EduCategory/' + guid);
    }

    saveEduCategory(cat: any) {
        if (cat.guid && cat.guid.length > 0)
            return this.http.put(this.BaseURI + '/EduCategory', cat);
        else
            return this.http.post(this.BaseURI + '/EduCategory', cat);
    }
}